import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './ButtonComponent.vue';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 relative whitespace-nowrap rounded-lg text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        primary: 'bg-brand-600 w-full relative text-white hover:bg-brand-700 disabled:opacity-50 disabled:bg-brand-600',
        primaryOutline:
          'border border-brand-600 text-brand-600 bg-white hover:bg-brand-50 disabled:opacity-50 disabled:border-brand-600 disabled:text-brand-600',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline: 'border border-input bg-background shadow-sm hover:text-grey-light-800 hover:bg-grey-light-50',
        secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-8 px-3 text-xs',
        lg: 'h-10 px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
